import { GripVertical } from 'lucide-react';
import type { ArrastrePuntero } from '../../hooks/useArrastrePuntero';

/**
 * Lo que el dedo lleva mientras arrastra.
 *
 * El arrastre nativo del escritorio pinta su propia imagen fantasma; con el
 * dedo no hay ninguna, y sin algo que se mueva con la mano el gesto se vuelve
 * un acto de fe: no se sabe si el sistema entendió que se levantó la ficha ni
 * qué se está por soltar.
 *
 * Va pegado al dedo uno a uno —sin transición de por medio, que introduciría
 * un retraso constante entre la mano y lo que se ve— y un poco por encima, para
 * que el propio dedo no lo tape justo cuando hay que decidir dónde soltarlo.
 */
export function FantasmaArrastre({ puntero }: { puntero: ArrastrePuntero }) {
  if (!puntero.levantado || !puntero.posicion) return null;

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed z-50 flex max-w-[14rem] items-center gap-1.5 rounded-md border border-primary bg-surface-raised px-2.5 py-1.5 shadow-lg"
      style={{
        left: puntero.posicion.x,
        top: puntero.posicion.y,
        // Centrado en horizontal y levantado 2.5rem: el pulgar tapa justo la
        // zona donde si no estaría el nombre de lo que se lleva.
        transform: 'translate(-50%, -2.5rem)',
      }}
    >
      <GripVertical className="h-3.5 w-3.5 shrink-0 text-primary" />
      <span className="truncate font-sans text-xs font-semibold text-content">
        {puntero.etiqueta}
      </span>
    </div>
  );
}
